import jwtDecode from 'jwt-decode';
import axios from 'axios';

import config from '../../config/config';

// content type
axios.defaults.headers.post['Content-Type'] = 'application/json';
axios.defaults.baseURL = config.API_URL;
// axios.defaults.headers.common['Authorization'] = 'Token ' + 'devjupiter';

// intercepting to capture errors
axios.interceptors.response.use(
    (response) => {
        return response;
    },
    (error) => {
        // Any status codes that falls outside the range of 2xx cause this function to trigger
        let message;

        if (axios.isCancel(error)) {
            if (process.env.NODE_ENV === 'development') {
                console.log('request canceled in cleanup');
            }
            return Promise.reject(error);
        }

        if (error && error.response && error.response.status === 404) {
            // window.location.href = '/not-found';
        } else if (error && error.response && error.response.status === 403) {
            // window.location.href = '/access-denied';
        } else if (error && error.response) {
            switch (error.response.status) {
                case 401:
                    message = 'Invalid credentials';
                    break;
                case 403:
                    message = 'Access Forbidden';
                    break;
                case 404:
                    message = 'Sorry! the data you are looking for could not be found';
                    break;
                default: {
                    message =
                        error.response && error.response.data ? error.response.data['message'] : error.message || error;
                }
            }
            return Promise.reject(message);
        } else {
            console.error(error)
            return Promise.reject(error.message);
        }
    }
);

const AUTH_SESSION_KEY = 'ubold_user';

/**
 * Sets the default authorization
 * @param {*} token
 */
const setAuthorization = (token: string | null) => {
    if (token) axios.defaults.headers.common['Authorization'] = 'Token ' +
        token;
    else delete axios.defaults.headers.common['Authorization'];
};

const getUserFromCookie = () => {
    const user = sessionStorage.getItem(AUTH_SESSION_KEY);
    return user ? (typeof user == 'object' ? user : JSON.parse(user)) : null;
};

class APICore {

    async get(url: string, params?: any) {
        const instance = axios.create();
        if (params) {
            instance.defaults.params = params;
        }
        return await instance.get(url);
    };

    /**
     * Updates data
     */
    async update(url: string, data: any) {
        const instance = axios.create({
            headers: {
                patch: {
                    'Content-Type': 'application/merge-patch+json',
                },
            },
        });
        return await instance.patch(url, data);
    };

    /**
     * post given data to url
     */
    async create(url: string, data: any) {
        const instance = axios.create();
        return await instance.post(url, data);
    };

    getFile = (url: string, params: any) => {
        let response;
        if (params) {
            var queryString = params
                ? Object.keys(params)
                    .map((key) => key + '=' + params[key])
                    .join('&')
                : '';
            response = axios.get(
                `${url}?${queryString}`,
                {responseType: 'blob'},
            );
        } else {
            response = axios.get(`${url}`, {responseType: 'blob'});
        }
        return response;
    };

    getMultiple = (urls: string, params: any) => {
        const reqs = [];
        let queryString = '';
        if (params) {
            queryString = params
                ? Object.keys(params)
                    .map((key) => key + '=' + params[key])
                    .join('&')
                : '';
        }

        for (const url of urls) {
            reqs.push(axios.get(`${url}?${queryString}`));
        }
        return axios.all(reqs);
    };

    /**
     * Deletes data
     */
    delete = (url: string) => {
        const instance = axios.create();
        return instance.delete(url);
    };

    /**
     * post given data to url with file
     */
    createWithFile = (url: string, data: any) => {
        const formData = new FormData();
        for (const k in data) {
            formData.append(k, data[k]);
        }

        const config = {
            headers: {
                ...axios.defaults.headers,
                'content-type': 'multipart/form-data',
            },
        };
        // @ts-ignore
        return axios.post(url, formData, config);
    };

    /**
     * post given data to url with file
     */
    updateWithFile = (url: string, data: any) => {
        const formData = new FormData();
        for (const k in data) {
            formData.append(k, data[k]);
        }

        const config = {
            headers: {
                ...axios.defaults.headers,
                'content-type': 'multipart/form-data',
            },
        };
        // @ts-ignore
        return axios.patch(url, formData, config);
    };

    isUserAuthenticated = () => {
        const user = this.getLoggedInUser();

        if (!user) {
            return false;
        }
        const decoded: any = jwtDecode(user.token);
        const currentTime = Date.now() / 1000;
        if (decoded.exp < currentTime) {
            console.warn('access token expired');
            return false;
        } else {
            return true;
        }
    };

    setLoggedInUser = (session: any) => {
        if (session) sessionStorage.setItem(
            AUTH_SESSION_KEY,
            JSON.stringify(session),
        );
        else {
            sessionStorage.removeItem(AUTH_SESSION_KEY);
        }
    };
    /**
     * Returns the logged in user
     */
    getLoggedInUser = () => {
        return getUserFromCookie();
    };

    setUserInSession = (modifiedUser: any) => {
        let userInfo = sessionStorage.getItem(AUTH_SESSION_KEY);
        if (userInfo) {
            const {token, user} = JSON.parse(userInfo);
            this.setLoggedInUser({token, ...user, ...modifiedUser});
        }
    };
}

/*
Check if token available in session
*/
let user = getUserFromCookie();
if (user) {
    const {token} = user;
    if (token) {
        setAuthorization(token);
    }
}

export {APICore, setAuthorization};
